import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)<{ backgroundImage: string }>`
  --background: url(${(props) => props.backgroundImage}) center/cover no-repeat;

  .content-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 48px 16px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
  }

  .page-title {
    margin-bottom: 24px;
    text-transform: none;
  }

  .top-title {
    margin: 8px 16px 0;
    text-align: center;
  }

  .progress-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 10;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    z-index: 10;
  }
`;

export const SubtitleStyles = styled(UiTypography)`
  color: var(--text-color-neutral-white);
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-top: 12px;
  text-transform: none;
  white-space: normal;
  word-break: break-word;
  max-width: 300px;
`;
